import { ModelMixin } from '@models/core/base-generic.model';

export class HoursApprovalReminder extends ModelMixin<HoursApprovalReminder>() {
    protected static _resource = 'payroll/sendEmployeeHoursApprovalReminder';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['subject', 'message_body', 'pay_period_start_date', 'pay_period_end_date'];

    get subject(): string {
        return this._attributes['subject'];
    }

    set subject(value: string) {
        this._attributes['subject'] = value;
    }

    get messageBody(): string {
        return this._attributes['message_body'];
    }

    set messageBody(value: string) {
        this._attributes['message_body'] = value;
    }

    get payPeriodStartDate(): string {
        return this._attributes['pay_period_start_date'];
    }

    set payPeriodStartDate(value: string) {
        this._attributes['pay_period_start_date'] = value;
    }

    get payPeriodEndDate(): string {
        return this._attributes['pay_period_end_date'];
    }

    set payPeriodEndDate(value: string) {
        this._attributes['pay_period_end_date'] = value;
    }
}
